<template>
  <div>
    <Head title="Pengeluaran Barangs" />
    <h1 class="mb-8 text-3xl font-bold">
      Transaksi
      <span class="text-indigo-400 font-medium"> / </span>
      Pengeluaran Barang
    </h1>
    <div class="flex items-center justify-between mb-6">
      <Link class="btn-indigo" href="/stockouts/create">
        <span>Create</span>
        <span class="hidden md:inline">&nbsp;Pengeluaran Barang</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto w-full md:max-w-4xl">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">
              Nomor
            </th>
            <th class="pb-4 pt-6 px-6">
              Nomor PR
            </th>
            <th class="pb-4 pt-6 px-6">
              Lampiran
            </th>
            <th class="pb-4 pt-6 px-6">
              Tanggal
            </th>
            <th class="pb-4 pt-6 px-6" colspan="2">
              Status
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="stockOut in stockOuts.data"
            :key="stockOut.id"
            class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/stockouts/${stockOut.id}/edit`">
                {{ stockOut.code }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="`/stockouts/${stockOut.id}/edit`"
                tabindex="-1">
                {{ stockOut.purchasereqm.code }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex py-4 px-10"
                :href="`/stockouts/${stockOut.id}/edit#attachments`"
                tabindex="-1">
                <Icon name="attachment" v-if="stockOut.has_attachment" />
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="flex items-center px-6 py-4"
                :href="`/stockouts/${stockOut.id}/edit`"
                tabindex="-1">
                {{ stockOut.trn_date }}
              </Link>
            </td>
            <td class="border-t whitespace-normal">
              <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/stockouts/${stockOut.id}/edit`">
                {{ stockOut.status }}
              </Link>
            </td>
            <td class="border-t whitespace-normal">
              <a
                v-if="stockOut.status === 'LOCKED'"
                :href="`/stockouts/${stockOut.id}/print`"
                as="button"
                target="_blank"
                class="bg-green-500 p-2 m-2 rounded text-white text-sm font-bold whitespace-nowrap hover:bg-orange-400 focus:bg-green-400">
                Print
              </a>
            </td>
          </tr>
          <tr v-if="stockOuts.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="3">
              No stock out found.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="stockOuts.links" />
  </div>
</template>

<script lang="js">
import { Head, Link } from '@inertiajs/vue3'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import Icon from '@/Shared/Icon'

export default {
    components: {
        Head,
        Link,
        Pagination,
        Icon,
    },
    layout: Layout,
    props: {
        filters: Object,
        stockOuts: Object,
    },
    data () {
        return {
            form: {
                search: this.filters.search,
                project: this.filters.project,
            },
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get('/stockouts', pickBy(this.form), { preserveState: true })
            }, 150),
        },
    },
    methods: {
        reset () {
            this.form = mapValues(this.form, () => null)
        },
    },
}
</script>
